import { apiClient } from '@/lib/api-client'
import type { Concept, Layer } from '@/types/terms'

/** The concept a term belongs to. Returns null when it is not linked yet. */
export async function getTermConcept(termId: number, layer: Layer): Promise<Concept | null> {
  const { data } = await apiClient.get<Concept | Record<string, never>>(
    `/terms/${termId}/concept`,
    { params: { layer } },
  )
  return data && 'concept_id' in data && data.concept_id ? (data as Concept) : null
}

/** Distinct domains in one collection, for the filter list. */
export async function getDomains(collectionId: number | null): Promise<string[]> {
  const { data } = await apiClient.get<{ domains?: string[] }>('/terms/domains', {
    params: collectionId ? { collection_id: collectionId } : {},
  })
  return data.domains ?? []
}
